import { render, staticRenderFns } from "./dayiOption.vue?vue&type=template&id=8aec9828&scoped=true&"
import script from "./dayiOption.vue?vue&type=script&lang=js&"
export * from "./dayiOption.vue?vue&type=script&lang=js&"
import style0 from "./dayiOption.vue?vue&type=style&index=0&id=8aec9828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec9828",
  null
  
)

export default component.exports